/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_Rtl_TextInputs */

const en_fix_rtl_text = /** @type {(inputs: Fix_Rtl_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix RTL Text`)
};

const fr_fix_rtl_text = /** @type {(inputs: Fix_Rtl_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corriger le texte RTL`)
};

const de_fix_rtl_text = /** @type {(inputs: Fix_Rtl_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL-Text korrigieren`)
};

const it_fix_rtl_text = /** @type {(inputs: Fix_Rtl_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correggi il testo RTL`)
};

const ru_fix_rtl_text = /** @type {(inputs: Fix_Rtl_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исправление текста, написанного справа налево (RTL).`)
};

const es_fix_rtl_text = /** @type {(inputs: Fix_Rtl_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corregir texto RTL`)
};

const zh_cn2_fix_rtl_text = /** @type {(inputs: Fix_Rtl_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修复 RTL 文本`)
};

const ja_fix_rtl_text = /** @type {(inputs: Fix_Rtl_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTLテキストを修正`)
};

const hi_fix_rtl_text = /** @type {(inputs: Fix_Rtl_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आरटीएल टेक्स्ट को ठीक करें`)
};

const pt_pt2_fix_rtl_text = /** @type {(inputs: Fix_Rtl_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrigir texto da direita para a esquerda`)
};

/**
* | output |
* | --- |
* | "Fix RTL Text" |
*
* @param {Fix_Rtl_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const fix_rtl_text = /** @type {((inputs?: Fix_Rtl_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Rtl_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_fix_rtl_text(inputs)
	if (locale === "de") return de_fix_rtl_text(inputs)
	if (locale === "it") return it_fix_rtl_text(inputs)
	if (locale === "ru") return ru_fix_rtl_text(inputs)
	if (locale === "es") return es_fix_rtl_text(inputs)
	if (locale === "zh-CN") return zh_cn2_fix_rtl_text(inputs)
	if (locale === "ja") return ja_fix_rtl_text(inputs)
	if (locale === "hi") return hi_fix_rtl_text(inputs)
	if (locale === "pt-PT") return pt_pt2_fix_rtl_text(inputs)
	return en_fix_rtl_text(inputs)
});